import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import fastdom from 'fastdom';
import { classNames } from './classNames';
import { isBreakpoint } from './lib/detect';
import { scrollTo } from './lib/scroller';

class Clue extends Component {
  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.props.isCompleted) {
      this.props.setReturnPosition();
      this.props.focusFirstCellInClueById(this.props.id);
    }
  }

  render() {
    return (
      <li>
        <a
          href={`#${this.props.id}`}
          onClick={this.onClick.bind(this)}
          className={classNames({
            crossword__clue: true,
            'text-white flex items-center mb-1 group px-6': true,
            'hover:bg-white hover:bg-opacity-20': !this.props.isSelected,
            'text-grey': this.props.hasAnswered && !this.props.isSelected,
            'bg-white font-semibold text-black': this.props.isSelected,
            'crossword__clue--display-group-order':
                            JSON.stringify(this.props.number)
                            !== this.props.humanNumber,
          })}
        >
          <div className="text-grey w-6 font-semibold">
            {this.props.humanNumber}.
          </div>
          <div
            className={classNames({
              "py-1 flex-1": true,
              'line-through': this.props.isCompleted
            })}
          >
            {this.props.isCompleted && (<i className="fas fa-check text-success text-sm mr-2"></i>)}
            {this.props.isErroned && (<i className="fas fa-times text-danger text-sm mr-2"></i>)}
            <span dangerouslySetInnerHTML={{ __html: this.props.clue }} />
          </div>
        </a>
      </li>
    );
  }
}

class Clues extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showGradient: true,
    };
  }

  componentDidMount() {
    this.$cluesNode = findDOMNode(this.clues);
  }

  /**
     * Scroll clues into view when they're activated (i.e. clicked in the grid)
     */
  componentDidUpdate(prev) {
    if (
      isBreakpoint({
        min: 'tablet',
        max: 'leftCol',
      })
            && (this.props.focussed
                && (!prev.focussed || prev.focussed.id !== this.props.focussed.id))
    ) {
      fastdom.read(() => {
        this.scrollIntoView(this.props.focussed);
      });
    }
  }

  scrollIntoView(clue) {
    const buffer = 100;
    const node = findDOMNode(this[clue.id]);
    const visible = node.offsetTop - buffer > this.$cluesNode.scrollTop
            && node.offsetTop + buffer
                < this.$cluesNode.scrollTop + this.$cluesNode.clientHeight;

    if (!visible) {
      const offset = node.offsetTop - this.$cluesNode.clientHeight / 2;
      scrollTo(offset, 250, 'easeOutQuad', this.$cluesNode);
    }
  }

  render() {
    const cluesByDirection = direction => this.props.clues
      .filter(clue => clue.entry.direction === direction)
      .map(clue => (
        <Clue
          ref={(clueRef) => {
            this[clue.entry.id] = clueRef;
          }}
          id={clue.entry.id}
          key={clue.entry.id}
          number={clue.entry.number}
          humanNumber={clue.entry.humanNumber}
          clue={clue.entry.clue}
          hasAnswered={clue.hasAnswered}
          isSelected={clue.isSelected}
          isCompleted={clue.isCompleted}
          isErroned={clue.isErroned}
          focusFirstCellInClueById={
                            this.props.focusFirstCellInClueById
                        }
          setReturnPosition={() => {
            this.props.setReturnPosition(window.scrollY);
          }}
        />
      ));

    return (
      <div
        className={`crossword__clues--wrapper ${
          this.state.showGradient ? '' : 'hide-gradient'
        }`}
      >
        <div
          className="crossword__clues"
          ref={(clues) => {
            this.clues = clues;
          }}
        >
          <div className="crossword__clues--across">
            <h3 className="text-white inline-block mb-2 font-semibold px-6">Horizontalement :</h3>
            <ol className="crossword__clues-list">
              {cluesByDirection('across')}
            </ol>
          </div>
          <div className="crossword__clues--down">
            <h3 className="text-white inline-block mb-2 font-semibold px-6">Verticalement :</h3>
            <ol className="crossword__clues-list">
              {cluesByDirection('down')}
            </ol>
          </div>
        </div>
        <div className="crossword__clues__gradient" />
      </div>
    );
  }
}

export { Clues };
